import { atom } from 'recoil'
import { GetEstateListResponseDataModel } from '../service/estate/model/get-estate-list-response-model'

export const myEstateListAtom = atom<Array<GetEstateListResponseDataModel>>({
  key: 'myEstateList',
  default: [],
})